<p class="status-title">
  {{ title | translate }}
  {{ totalElements ? totalElements : "" }}

  <mat-icon
    *ngIf="icon"
    [fontIcon]="icon"
    [matTooltip]="tooltip | translate"
    matTooltipShowDelay="0"
    matTooltipHideDelay="0"
  ></mat-icon>
</p>

<section class="cards-alignment">
  <ng-container *ngFor="let card of cards">
    <ng-container
      [ngTemplateOutlet]="cardTemplate"
      [ngTemplateOutletContext]="{ card: card }"
    ></ng-container>
  </ng-container>
</section>
